




import { Component, Vue } from "vue-property-decorator";

@Component({
  components: {
    "date-range-stat": () =>
      import("@/components/app/global/stats/_dateRangeStat.vue")
  }
})
export default class ClientsTotalNew extends Vue {
  private get params() {
    return {
      type: "clients"
    };
  }

  public get attrs() {
    return this.$_.merge(
      {
        id: "clientsStats",
        label: this.$t("_.new_clients"),
        params: this.params,
        scope: "clients",
        currencyCode: null,
        currencyBound: false,
        valuePath: `total.result[0].count`
      },
      this.$attrs
    );
  }
}
